<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [attr.viewBox]="viewBoxString"
  preserveAspectRatio="xMinYMin"
  id="door-image"
  class="cabinet-section-2d"
  [class]="{ dragging: !!dragInfo }"
  (mousemove)="mouseMove($event)"
  (mouseup)="mouseUp($event)"
  (click)="selectedBar = null; selectedFilling = null; selectedOverlap = null"
>
  <g class="front-view">
    <g class="corpus">
      <g class="corpus-items">
        <g
          *ngFor="let item of corpusItems"
          class="corpus-item"
          [attr.transform]="getItemTransformString(item)"
        >
          <image
            width="0"
            height="0"
            class="item-material-only-fallback"
            href=""
            [attr.href]="item.Material.ImagePath"
            *ngIf="!item.getModel2DPath() &amp;&amp; item.Material &amp;&amp; item.Material.ImagePath"
            preserveAspectRatio="none"
            [attr.height]="item.Height"
            [attr.width]="item.Width"
          />

          <rect
            width="0"
            height="0"
            class="item-no-img-fallback"
            *ngIf="!item.getModel2DPath()"
            style="stroke: gray; stroke-width: 2px; fill: rgba(0, 0, 0, 0.01)"
            [attr.height]="item.Height"
            [attr.width]="item.Width"
          ></rect>

          <g class="item-ruler" *ngIf="showRulers">
            <rect
              class="item-ruler-background"
              style="fill: rgba(255, 255, 255, 0.5)"
              width="80"
              height="70"
              [attr.x]="(item.Width - 80) / 2"
              [attr.y]="(item.Height - 70) / 2"
            ></rect>

            <text
              class="item-ruler-text"
              style="font-size: 40px; pointer-events: none"
              [attr.x]="item.Width / 2"
              [attr.y]="item.Height / 2 + 13"
              text-anchor="middle"
            >
              {{ item.PositionNumber }}
            </text>
          </g>
        </g>
      </g>
      <g class="corpus-joints">
        <g
          class="corpus-joint"
          *ngFor="let joint of corpusJoints"
          attr.transform="translate( {{ joint.X }} {{
            cabinetSection.Height - joint.Y
          }} )"
        >
          <line
            x1="0"
            x2="0"
            y1="0"
            y2="0"
            [attr.y2]="-joint.height"
            style="stroke: black; stroke-width: 10px"
          ></line>
        </g>
      </g>
    </g>

    <rect
      class="cabinet-section-border"
      x="0"
      y="0"
      width="0"
      height="0"
      style="fill: none; stroke: black; stroke-width: 3px"
      [attr.width]="cabinetSection.Width"
      [attr.height]="cabinetSection.Height"
    ></rect>

    <g
      *ngFor="let door of doorsOrderedByPositionZ"
      class="door"
      attr.transform="translate({{ door.position.X }} {{
        cabinetSection.Height - door.position.Y - door.size.Y
      }})"
    >
      <g
        *ngFor="let filling of door.fillings"
        class="filling"
        attr.transform="translate({{ filling.positionX }} {{
          door.size.Y - filling.positionY - filling.height
        }})"
        (click)="selectedFilling = filling; $event.stopPropagation()"
        [class]="{ selected: filling === selectedFilling }"
      >
        <image
          *ngIf="!useCorrectlySizedMaterials(door, filling)"
          width="1"
          height="1"
          preserveAspectRatio="none"
          style="image-rendering: auto"
          attr.transform="{{ getFillingTransformString(door, filling) }}"
          [attr.href]="getFillingImagePath(door, filling)"
        />

        <g *ngIf="useCorrectlySizedMaterials(door, filling)">
          <defs>
            <pattern
              [id]="getFillingPatternId(door, filling)"
              *ngIf="filling.isDesignFilling &amp;&amp; filling.material"
              [attr.viewBox]="
                '0 0 ' +
                filling.material.TextureHeightMm +
                ' ' +
                filling.material.TextureWidthMm
              "
              [attr.width]="filling.material.TextureHeightMm"
              [attr.height]="filling.material.TextureWidthMm"
              patternUnits="userSpaceOnUse"
            >
              <image
                width="1"
                height="1"
                [attr.width]="filling.material.TextureWidthMm"
                [attr.height]="filling.material.TextureHeightMm"
                attr.transform="rotate( 270 ) translate( {{
                  -(filling?.material?.TextureWidthMm ?? 0)
                }} 0 )"
                preserveAspectRatio="none"
                style="image-rendering: auto"
                [attr.href]="getTextureUrl(filling.material)"
              />
            </pattern>
            <pattern
              [id]="getFillingPatternId(door, filling)"
              *ngIf="!filling.isDesignFilling &amp;&amp; filling.material"
              [attr.viewBox]="
                '0 0 ' +
                filling.material.TextureWidthMm +
                ' ' +
                filling.material.TextureHeightMm
              "
              [attr.width]="filling.material.TextureWidthMm"
              [attr.height]="filling.material.TextureHeightMm"
              patternUnits="userSpaceOnUse"
            >
              <image
                width="1"
                height="1"
                [attr.width]="filling.material.TextureWidthMm"
                [attr.height]="filling.material.TextureHeightMm"
                preserveAspectRatio="none"
                style="image-rendering: auto"
                [attr.href]="getTextureUrl(filling.material)"
              />
            </pattern>
          </defs>
          <rect
            [attr.fill]="'url(#' + getFillingPatternId(door, filling) + ')'"
            width="1"
            height="1"
            [attr.width]="filling.width"
            [attr.height]="filling.height"
            stroke-width="0"
          />
        </g>

        <rect
          class="select-marker"
          width="0"
          height="0"
          [attr.width]="filling.width"
          [attr.height]="filling.height"
          style="opacity: 0"
        ></rect>
      </g>

      <g class="profiles">
        <g
          class="profile"
          *ngFor="let profile of door.profiles"
          attr.transform="translate( {{ profile.position.X }} {{
            door.size.Y - profile.position.Y - profile.size.Y
          }})"
        >
          <image
            class="material"
            width="0"
            height="0"
            preserveAspectRatio="none"
            [attr.width]="1"
            [attr.height]="1"
            [attr.transform]="profileImageTransform(profile)"
            [attr.href]="profile.material?.ImagePath"
          ></image>
          <rect
            class="outline"
            style="fill: none; stroke: grey; stroke-width: 2px"
            width="0"
            height="0"
            [attr.width]="profile.size.X"
            [attr.height]="profile.size.Y"
          ></rect>
        </g>
      </g>

      <g
        *ngFor="let bar of door.verticalBars"
        class="bar"
        style="pointer-events: none"
        attr.transform="translate( {{ bar.positionX }} {{
          door.frameHeightTop
        }} )"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="rotate(0) scale({{ bar.width }} {{ bar.height }})"
          [attr.href]="cabinetSection.doors.profileMaterial?.ImagePath"
        ></image>

        <rect
          class="outline"
          style="fill: none; stroke: grey; stroke-width: 2px"
          width="0"
          height="0"
          [attr.width]="bar.width"
          [attr.height]="bar.height"
        ></rect>
      </g>

      <g *ngIf="showRulers">
        <g
          *ngFor="let filling of door.fillings"
          class="filling"
          attr.transform="translate({{ filling.positionX }} {{
            door.size.Y - filling.positionY - filling.height
          }})"
        >
          <rect
            class="item-ruler-background"
            width="0"
            style="fill: rgba(255, 255, 255, 0.5); pointer-events: none"
            height="95"
            [attr.width]="getLabelWidth(filling)"
            [attr.y]="filling.height - 130"
            [attr.x]="(filling.width - getLabelWidth(filling)) / 2"
          ></rect>

          <text
            class="item-ruler-text"
            style="
              text-align: center;
              width: 100%;
              font-size: 45px;
              text-align: center;
              margin: auto;
              padding: 6px 12px;
              pointer-events: none;
            "
            [attr.x]="filling.width / 2"
            [attr.y]="filling.height - 70"
            text-anchor="middle"
          >
            {{ getLabel(filling) }}
          </text>
        </g>
      </g>

      <g
        *ngFor="let bar of door.bars"
        class="bar"
        attr.transform="translate({{ door.frameWidthLeft }} {{
          door.size.Y -
            (bar?.position ?? 0) -
            (cabinetSection.doors.barHeight ?? 0)
        }})"
        (click)="selectedBar = bar; $event.stopPropagation()"
        (mousedown)="startDrag($event, bar)"
        [class]="{ selected: bar === selectedBar }"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="rotate(270) scale( {{
            cabinetSection.doors.barHeight
          }} {{ door.size.X - 2 * door.frameWidthLeft }} ) translate( -1 )"
          [attr.href]="cabinetSection.doors.profileMaterial?.ImagePath"
        ></image>

        <rect
          class="outline"
          style="fill: none; stroke: grey; stroke-width: 2px"
          width="0"
          height="0"
          [attr.width]="door.size.X - 2 * door.frameWidthLeft"
          [attr.height]="cabinetSection.doors.barHeight"
        ></rect>

        <rect
          class="select-marker"
          style="opacity: 0"
          width="0"
          height="0"
          [attr.width]="door.size.X - 2 * door.frameWidthLeft"
          [attr.height]="cabinetSection.doors.barHeight"
        ></rect>

        <foreignObject
          width="600"
          height="95"
          y="-20"
          style="pointer-events: none"
          [attr.width]="bar.width"
          *ngIf="showRulers"
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="text-align: center; width: 100%"
          >
            <span
              style="
                background-color: rgba(255, 255, 255, 0.5);
                font-size: 45px;
                text-align: center;
                margin: auto;
                padding: 6px 12px;
              "
              [textContent]="bar.centerY.toFixed(0)"
            ></span>
          </div>
        </foreignObject>
      </g>

      <g
        class="grip"
        *ngFor="let gripItem of door.gripItemsFront"
        attr.transform="translate( {{ gripItem.X }} {{
          door.size.Y - gripItem.Y - gripItem.Height
        }})"
      >
        <image
          width="0"
          height="0"
          preserveAspectRatio="none"
          [attr.href]="door.gripImagePath"
          *ngIf="door.gripImagePath"
          [attr.width]="gripItem.Width"
          [attr.height]="gripItem.Height"
          attr.transform="scale( {{
            gripItem.isMirrored ? -1 : 1
          }} 1 ) translate( {{ gripItem.isMirrored ? -gripItem.Width : 0 }} 0 )"
        />
      </g>

      <rect
        class="door-outline"
        x="0"
        y="0"
        width="0"
        height="0"
        *ngIf="!door.profiles.length"
        [attr.width]="door.width"
        [attr.height]="door.height"
        style="fill: none; stroke: black; stroke-width: 3px"
      ></rect>
    </g>

    <g
      *ngIf="dragInfo &amp;&amp; dragInfo.type === 'dragBar' &amp;&amp; dragInfo.dragStarted"
      class="drag-bar-hint"
    >
      <rect
        x="0"
        y="0"
        width="0"
        height="0"
        [attr.x]="dragInfo.currentDisplayPos.X"
        [attr.y]="dragInfo.currentDisplayPos.Y"
        [attr.width]="dragInfo.currentDisplayPos.Width"
        [attr.height]="dragInfo.currentDisplayPos.Height"
      ></rect>
    </g>

    <g
      *ngIf="cornerMoulding"
      class="door"
      attr.transform="translate({{ cornerMoulding.X }} {{
        cabinetSection.Height - cornerMoulding.Y - cornerMoulding.Height
      }} )"
    >
      <image
        class="material"
        width="0"
        height="0"
        preserveAspectRatio="none"
        [attr.width]="cornerMoulding.Width == null"
        [attr.height]="cornerMoulding.Height == null"
        [attr.href]="cornerMoulding.Material?.ImagePath == null"
      ></image>
      <rect
        class="outline"
        style="fill: none; stroke: grey; stroke-width: 2px"
        width="0"
        height="0"
        [attr.width]="cornerMoulding.Width == null"
        [attr.height]="cornerMoulding.Height == null"
      ></rect>
    </g>

    <g class="rails">
      <g
        *ngFor="let item of cabinetSection.doors.railItems"
        class="rail"
        attr.transform="translate( {{ item.X }}  {{
          cabinetSection.Height - item.topY
        }} )"
      >
        <g *ngIf="item.Material?.ImagePath">
          <image
            width="0"
            height="0"
            preserveAspectRatio="none"
            [attr.href]="item.Material?.ImagePath ?? ''"
            [attr.width]="item.Width"
            [attr.height]="item.Height"
          />

          <rect
            width="0"
            height="0"
            class="outline"
            style="fill: none; stroke: grey; stroke-width: 2px"
            [attr.width]="item.Width"
            [attr.height]="item.Height"
          ></rect>
        </g>

        <rect
          width="0"
          height="0"
          class="item-no-img-fallback"
          *ngIf="!item.Material?.ImagePath"
          [attr.height]="item.Height"
          [attr.width]="item.Width"
        />
      </g>
    </g>

    <g class="pullout-warnings" *ngIf="showPullout">
      <rect
        class="pullout-warning"
        *ngFor="let pullout of cabinetSection.doors.pulloutWarningAreas"
        [class]="{
          'pullout-severity-info': pullout.severity === 0,
          'pullout-severity-warning': pullout.severity === 1,
          'pullout-severity-critical': pullout.severity === 2,
        }"
        width="0"
        height="0"
        style="pointer-events: none"
        [attr.x]="pullout.start"
        [attr.width]="pullout.end - pullout.start"
        [attr.y]="
          cabinetSection.Height -
          cabinetSection.SightHeight -
          cabinetSection.sightOffsetY
        "
        [attr.height]="cabinetSection.SightHeight"
      ></rect>
    </g>

    <g *ngIf="cabinetSection.doors.manualOverlapPositioning">
      <g
        *ngFor="let overlap of cabinetSection.doors.overlaps"
        attr.transform="translate({{ overlap.visualLeft }} {{
          cabinetSection.Height -
            cabinetSection.SightHeight -
            cabinetSection.sightOffsetY
        }})"
        [class]="{ selected: overlap === selectedOverlap }"
      >
        <rect
          class="overlap select-marker"
          (click)="selectedOverlap = overlap; $event.stopPropagation()"
          style="opacity: 0"
          width="0"
          height="0"
          [attr.width]="overlap.visualRight - overlap.visualLeft"
          [attr.height]="cabinetSection.SightHeight"
        ></rect>
      </g>
    </g>
  </g>
  <g
    class="topdown-view"
    attr.transform="translate({{ topDownPosX }} {{ topDownPosY }})"
    *ngIf="showTopDown"
  >
    <g
      class="door-topdown-group"
      *ngFor="let door of doors"
      attr.transform="translate({{ door.position.X }} {{ door.position.Z }})"
    >
      <rect
        class="door-topdown"
        x="0"
        y="0"
        width="0"
        height="0"
        style="fill: #111; stroke: #666; stroke-width: 3px"
        [attr.width]="door.size.X"
        [attr.height]="door.size.Z"
      ></rect>

      <text
        style="font-size: 40px"
        x="0"
        y="-10"
        [attr.x]="door.size.X / 2"
        text-anchor="middle"
      >
        {{ roundUp(door.size.X) }}
      </text>
    </g>

    <g *ngIf="cabinetSection.doors.manualOverlapPositioning">
      <g
        *ngFor="let overlap of cabinetSection.doors.overlaps"
        attr.transform="translate({{ overlap.visualLeft }} {{
          sectionDepth - railDepth - 130
        }})"
        [class]="{ selected: overlap === selectedOverlap }"
      >
        <rect
          class="overlap select-marker"
          (click)="selectedOverlap = overlap; $event.stopPropagation()"
          style="opacity: 0"
          width="0"
          height="0"
          [attr.width]="overlap.visualRight - overlap.visualLeft"
          [attr.Height]="railDepth + 150"
        ></rect>
      </g>
    </g>
  </g>

  <g class="ruler-view" *ngIf="showRulers" style="pointer-events: none">
    <g *ngFor="let ruler of rulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>
</svg>
